module.exports = __webpack_public_path__ + "static/media/Chat-app.ab0dec77.png";